
// export default ReviewsList;

import React from 'react';
import styled from 'styled-components';
import Review from './Review';

// You can keep this styled-component if you want tight control
const ReviewsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const ReviewsList = ({ reviews, onReportInappropriate }) => {
  const reviewsArray = reviews || [];

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <ReviewsListContainer className="col-12">
          {reviewsArray.map((review, index) => (
            <Review
              key={review._id?.$oid || review._id || review.id || index}
              review={review}
              onReportInappropriate={onReportInappropriate}
            />
          ))}
        </ReviewsListContainer>
      </div>
    </div>
  );
};

export default ReviewsList;
